// 颜色选择器和颜色名称显示功能
(function() {
  'use strict';

  // 颜色映射表（预定义）
  const colorMap = {
    '红色': '#FF0000', '蓝色': '#0000FF', '绿色': '#00FF00', '黑色': '#000000',
    '白色': '#FFFFFF', '灰色': '#808080', '粉色': '#FFC0CB', '紫色': '#800080',
    '橙色': '#FFA500', '黄色': '#FFFF00', 'Red': '#FF0000', 'Blue': '#0000FF',
    'Green': '#00FF00', 'Black': '#000000', 'White': '#FFFFFF', 'Gray': '#808080',
    'Pink': '#FFC0CB', 'Purple': '#800080', 'Orange': '#FFA500', 'Yellow': '#FFFF00'
  };

  // 从值中解析颜色名称（去掉16进制代码部分）
  function parseColorName(value) {
    // 如果是内嵌格式 (颜色名称#代码)，只返回颜色名称部分
    if (value.includes('#')) {
      const parts = value.split('#');
      return parts[0];
    }
    return value;
  }

  // 更新选项标题中的颜色名称
  function updateColorNameInTitle(optionContainer, selectedValue) {
    const colorNameSpan = optionContainer.querySelector('.selected-color-name');
    if (!colorNameSpan) return;

    const displayName = parseColorName(selectedValue);
    colorNameSpan.textContent = `: ${displayName}`;
  }

  // 监听变体选择变化 (按钮样式)
  function handleVariantRadioChange() {
    document.addEventListener('change', function(event) {
      if (event.target.type === 'radio' && event.target.name) {
        const fieldset = event.target.closest('fieldset');
        if (fieldset) {
          const legend = fieldset.querySelector('legend');
          const legendText = legend ? legend.textContent.trim() : '';
          
          // 检查是否是颜色选项
          if (legendText.includes('Color') || legendText.includes('color') || 
              legendText.includes('颜色') || legendText.includes('色彩')) {
            updateColorNameInTitle(fieldset, event.target.value);
          }
        }
      }
    });
  }

  // 监听变体选择变化 (下拉框样式)
  function handleVariantSelectChange() {
    document.addEventListener('change', function(event) {
      if (event.target.tagName === 'SELECT' && event.target.classList.contains('select__select')) {
        const container = event.target.closest('.product-form__input--dropdown');
        if (container) {
          const label = container.querySelector('label');
          const labelText = label ? label.textContent.trim() : '';
          
          // 检查是否是颜色选项
          if (labelText.includes('Color') || labelText.includes('color') || 
              labelText.includes('颜色') || labelText.includes('色彩')) {
            updateColorNameInTitle(container, event.target.value);
          }
        }
      }
    });
  }

  // 设置颜色选择器的样式和行为
  function setupColorSwatches() {
    const colorInputs = document.querySelectorAll('input[type="radio"][data-color]');
    
    colorInputs.forEach(input => {
      const label = input.nextElementSibling;
      if (label && label.tagName === 'LABEL') {
        // 确保标签有正确的类名
        if (input.dataset.color) {
          label.classList.add('color-swatch');
        }
        
        // 添加键盘支持
        label.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            input.click();
          }
        });
        
        // 添加可访问性属性
        label.setAttribute('tabindex', '0');
        label.setAttribute('role', 'button');
        label.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
        
        // 监听选中状态变化
        input.addEventListener('change', function() {
          // 更新所有同组的 aria-pressed 属性
          const sameNameInputs = document.querySelectorAll(`input[name="${input.name}"]`);
          sameNameInputs.forEach(sameInput => {
            const sameLabel = sameInput.nextElementSibling;
            if (sameLabel && sameLabel.tagName === 'LABEL') {
              sameLabel.setAttribute('aria-pressed', sameInput.checked ? 'true' : 'false');
            }
          });
        });
      }
    });
  }

  // 初始化
  function init() {
    // 设置颜色选择器
    setupColorSwatches();
    
    // 设置事件监听器
    handleVariantRadioChange();
    handleVariantSelectChange();
  }

  // 当DOM加载完成时初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 如果是Shopify主题编辑器，需要在内容变化时重新初始化
  document.addEventListener('shopify:section:load', init);

})();
